/** Translation keys used in Business Intelligence module */
export const enum BITextKey {
    ApplyFilters = 'ApplyFilters',
    CreateDashboard = 'CreateDashboard',
    CreatedBy = 'CreatedBy',
    DashboardCreatedSuccessfully = 'DashboardCreatedSuccessfully',
    DashboardDeletedSuccessfully = 'DashboardDeletedSuccessfully',
    DashboardDuplicatedSuccessfully = 'DashboardDuplicatedSuccessfully',
    DashboardEditedSuccessfully = 'DashboardEditedSuccessfully',
    DashboardPlural = 'DashboardPlural',
    DeleteDashboardConfirmationDialogContent = 'DeleteDashboardConfirmationDialogContent',
    DeleteDashboardConfirmationDialogHeader = 'DeleteDashboardConfirmationDialogHeader',
    DuplicateDashboard = 'DuplicateDashboard',
    InsightsErrorText = 'InsightsErrorText',
    InsightsErrorTitle = 'InsightsErrorTitle',
    InsightsHello = 'InsightsHello',
    InsightsHereIsWhatHasBeenHappening = 'InsightsHereIsWhatHasBeenHappening',
    InsightsMaintenanceDate = 'InsightsMaintenanceDate',
    InsightsMaintenanceText = 'InsightsMaintenanceText',
    InsightsMaintenanceTitle = 'InsightsMaintenanceTitle',
    InsightsNoAccessText = 'InsightsNoAccessText',
    InsightsNoAccessTitle = 'InsightsNoAccessTitle',
    InsightsOnboardingText = 'InsightsOnboardingText',
    InsightsOnboardingTitle = 'InsightsOnboardingTitle',
    InsightsThisMonthRevenue = 'InsightsThisMonthRevenue',
    InsightsTodaysAdr = 'InsightsTodaysAdr',
    InsightsTodaysCheckins = 'InsightsTodaysCheckins',
    InsightsTodaysCheckouts = 'InsightsTodaysCheckouts',
    InsightsTodaysOccupancy = 'InsightsTodaysOccupancy',
    InsightsTodaysRevPar = 'InsightsTodaysRevPar',
    InsightsViewDailySummary = 'InsightsViewDailySummary',
    LastUpdated = 'LastUpdated',
    LastUpdatedOnWithDate = 'LastUpdatedOnWithDate',
    MewsBI = 'MewsBI',
    MewsBIAllDashboards = 'MewsBIAllDashboards',
    MewsBIAllUsers = 'MewsBIAllUsers',
    MewsBICuratedDashboards = 'MewsBICuratedDashboards',
    MewsBICustomDashboards = 'MewsBICustomDashboards',
    MewsBIDashboardAdr = 'MewsBIDashboardAdr',
    MewsBIDashboardDailySummary = 'MewsBIDashboardDailySummary',
    MewsBIDashboardMultiProperty = 'MewsBIDashboardMultiProperty',
    MewsBIDashboardOccupancy = 'MewsBIDashboardOccupancy',
    MewsBIDashboardPickup = 'MewsBIDashboardPickup',
    MewsBIDashboardReservations = 'MewsBIDashboardReservations',
    MewsBIDashboardRevPAR = 'MewsBIDashboardRevPAR',
    MewsBIDashboardRevenue = 'MewsBIDashboardRevenue',
    MewsBIEmptyStateText = 'MewsBIEmptyStateText',
    MewsBIEmptyStateTitle = 'MewsBIEmptyStateTitle',
    PopularDashboardDailySummaryDescription = 'PopularDashboardDailySummaryDescription',
    PopularDashboardDailySummaryTitle = 'PopularDashboardDailySummaryTitle',
    PopularDashboardOccupancyDescription = 'PopularDashboardOccupancyDescription',
    PopularDashboardOccupancyTitle = 'PopularDashboardOccupancyTitle',
    PopularDashboardPickupDescription = 'PopularDashboardPickupDescription',
    PopularDashboardPickupTitle = 'PopularDashboardPickupTitle',
    PopularDashboardRevenueDescription = 'PopularDashboardRevenueDescription',
    PopularDashboardRevenueTitle = 'PopularDashboardRevenueTitle',
    PopularDashboardsTitle = 'PopularDashboardsTitle',
    SkipForNow = 'SkipForNow',
    WelcomeToBIAlertsDescription = 'WelcomeToBIAlertsDescription',
    WelcomeToBIAlertsTitle = 'WelcomeToBIAlertsTitle',
    WelcomeToBIBetaDialogTitle = 'WelcomeToBIBetaDialogTitle',
    WelcomeToBICreateEditDashboardDescription = 'WelcomeToBICreateEditDashboardDescription',
    WelcomeToBICreateEditDashboardTitle = 'WelcomeToBICreateEditDashboardTitle',
    WelcomeToBIManageMetricsDescription = 'WelcomeToBIManageMetricsDescription',
    WelcomeToBIManageMetricsTitle = 'WelcomeToBIManageMetricsTitle',
    WelcomeToBIShareDashboardDescription = 'WelcomeToBIShareDashboardDescription',
    WelcomeToBIShareDashboardTitle = 'WelcomeToBIShareDashboardTitle',
}

declare global {
    namespace Mews {
        /** Interface for merging text keys from various packages */
        interface TextKeysCollection {
            businessIntelligence: BITextKey;
        }
    }
}

export { BITextKey as TextKey };
